import React from "react";
import { withTranslation } from "react-i18next";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import CustomButton from "../../common/CustomButton";

const IssueProformaInvoicesModal = ({
  isModalOpen,
  loader,
  onIssueBtnHandler,
  onChooseBtnHandler,
  onCloseBtnHandler,
  t,
}) => {
  const handleModalClose = () => {
    if (!loader) onCloseBtnHandler();
  };

  return (
    <>
      <Modal centered isOpen={isModalOpen} toggle={handleModalClose} fade={false}>
        <ModalHeader>{t("common.issueProformaInvoices")}</ModalHeader>
        <ModalBody>{t("confirmation.issueProformaInvoices")}</ModalBody>
        <ModalFooter>
          <CustomButton
            isLoading={loader}
            color={"success"}
            btnTitle={t("common.issueAll")}
            onClick={() => {
              onIssueBtnHandler();
            }}
          />
          <CustomButton disabled={loader} btnTitle={t("common.choose")} onClick={onChooseBtnHandler} />
          <CustomButton disabled={loader} color={"dark"} btnTitle={t("common.cancel")} onClick={handleModalClose} />
        </ModalFooter>
      </Modal>
    </>
  );
};

export default withTranslation()(IssueProformaInvoicesModal);
